import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StringLabel = styled(Typography)(() => ({
  flex: '1 1 0',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  overflowWrap: 'break-word',
  textAlign: 'left',
  color: 'var(--Gray-700, #344054)',
  fontFamily: 'Inter',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '24px',
}));

export default StringLabel;
